import React from 'react';
import { LayoutList, Square, Settings2, Plus, Sliders } from 'lucide-react';
import { PlanCard } from './PlanCard';
import { PropertiesPanel } from './PropertiesPanel';
import { CanvasRenderer } from './CanvasRenderer';
import { TopToolbar } from './Toolbar';

export const MobileView = ({
    isPanning,
    mobileView, setMobileView, canManageProject, handleAddFloor, floorPlans, loading, handlePlanDragStart,
    handlePlanDragEnd, handlePlanDragOver, handleDragLeaveContainer, handlePlanDrop, handleCardDrop,
    draggedPlanId, dropIndicator,
    currentPlanStates, activePlanId, editingPlanId, handleDoubleClick, handleSetActive, tempName, setTempName,
    handleNameChange, handleKeyDown, triggerFileUpload, handleDeleteRequest, selectedEntityId, setSelectedEntityId,
    uploadProgress, expandedPlanId, handleToggleExpand, mobileCanvasRef, canvasStyle, handlePointerDown,
    handlePointerMove, handlePointerUp, tools, tool, setTool, canEdit, historyButtons, saveStatus,
    isMobileOpacityPanelOpen, setIsMobileOpacityPanelOpen, planOpacity, setPlanOpacity, entitiesOpacity,
    setEntitiesOpacity, transform, pdfPage, renderableEntities, unreadCounts, handleOpenFeedback, entities,
    selectedEntity, selectedEntityIds, focusedArea, isDark, handleEntityClick, onImageOrHandleMouseDown, onAnchorMouseDown, selectedEdgeIndices, handleEdgeClick,
    renderPreview, isRendering, canManageProperties, onPropertyChange, handleDeleteSelectedEntity, handleRestoreAspectRatio,
    materials, furniture, decorativeImages, handleMaterialSelect, handleFurnitureSelect,
    draggedOverPlanId, handleDragEnterCard, handleDragLeaveCard,
    isAreaComplete, onConfirmItem, currentUser, effectiveIsPreview, showConfirmations, onToggleConfirmations,
    exitingItemIds,
    draggedImageState,
    draggedAnchorState,
    displayMode,
    masterStyle,
    singleSelectedEntityId,
}) => {
    return (
        <div className="md:hidden h-full w-full flex flex-col">
            <div className="flex-grow min-h-0 relative">
                { mobileView === 'plans' && (
                    <div className="p-4 flex flex-col h-full">
                        <div className="flex justify-between items-center flex-shrink-0 mb-4">
                            <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-200">Floor Plans</h2>
                            {canManageProject && <button onClick={handleAddFloor} className="p-1 rounded-md text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-700">
                                <Plus className="h-5 w-5" />
                            </button>}
                        </div>
                        <div 
                            className="flex-grow overflow-y-auto pr-2"
                            onDragLeave={handleDragLeaveContainer}
                            onDragOver={(e) => e.preventDefault()}
                            onDrop={handlePlanDrop}
                        >
                        <div className="space-y-2 pr-1">
                            {floorPlans.map(plan => (
                                <div key={plan.id}
                                    className={`relative transition-transform duration-300 ease-in-out ${draggedPlanId === plan.id ? 'opacity-30' : 'opacity-100'}`}
                                >
                                    {dropIndicator?.targetId === plan.id && dropIndicator.position === 'before' && (
                                        <div className="absolute -top-1 left-0 right-0 h-1.5 bg-blue-500 rounded-full z-20 pointer-events-none"></div>
                                    )}
                                    <div
                                        draggable={canManageProject}
                                        onDragStart={e => handlePlanDragStart(e, plan.id)}
                                        onDragEnd={handlePlanDragEnd}
                                        onDragOver={e => handlePlanDragOver(e, plan.id)}
                                        onDrop={e => handleCardDrop(e, plan.id)}
                                    >
                                        <PlanCard 
                                            plan={plan} 
                                            planEntities={currentPlanStates?.[plan.id] || []}
                                            onSelectEntity={(entityId) => {
                                                handleSetActive(plan.id); 
                                                setSelectedEntityId(entityId);
                                                if (mobileView !== 'canvas') setMobileView('canvas');
                                            }}
                                            activePlanId={activePlanId}
                                            editingPlanId={editingPlanId}
                                            handleDoubleClick={handleDoubleClick}
                                            handleSetActive={handleSetActive}
                                            tempName={tempName}
                                            setTempName={setTempName}
                                            handleNameChange={handleNameChange}
                                            handleKeyDown={handleKeyDown}
                                            canManageProject={canManageProject}
                                            triggerFileUpload={triggerFileUpload}
                                            handleDeleteRequest={handleDeleteRequest}
                                            selectedEntityId={singleSelectedEntityId}
                                            uploadProgress={uploadProgress}
                                            isExpanded={expandedPlanId === plan.id}
                                            onToggleExpand={() => handleToggleExpand(plan.id)}
                                            draggedOverPlanId={draggedOverPlanId}
                                            handleDragEnterCard={handleDragEnterCard}
                                            handleDragLeaveCard={handleDragLeaveCard}
                                            isAreaComplete={isAreaComplete}
                                        />
                                    </div>
                                    {dropIndicator?.targetId === plan.id && dropIndicator.position === 'after' && (
                                        <div className="absolute -bottom-1 left-0 right-0 h-1.5 bg-blue-500 rounded-full z-20 pointer-events-none"></div>
                                    )}
                                </div>
                            ))}
                            {loading && (
                                <p className="text-sm text-center text-gray-500 dark:text-gray-400 py-10">Loading plans...</p>
                            )}
                        </div>
                        </div>
                    </div>
                )}
                { mobileView === 'canvas' && (
                    <div 
                        ref={mobileCanvasRef}
                        className="flex items-center justify-center bg-gray-100 dark:bg-gray-900 overflow-hidden relative h-full"
                        style={canvasStyle}
                        onPointerDown={handlePointerDown}
                        onPointerMove={handlePointerMove}
                        onPointerUp={handlePointerUp}
                        onPointerCancel={handlePointerUp}
                    >
                        <TopToolbar
                            tools={tools}
                            tool={tool}
                            setTool={setTool}
                            canEdit={canEdit}
                            setIsLibraryOpen={() => {}}
                            isPreview={false}
                            setIsPreview={() => {}}
                            canManageProject={canManageProject}
                            historyButtons={historyButtons}
                            saveStatus={saveStatus}
                            currentUser={currentUser}
                            showConfirmations={showConfirmations}
                            onToggleConfirmations={onToggleConfirmations}
                        />

                        <div className="absolute top-4 right-4 z-30 md:hidden">
                            <div className="flex flex-col items-end gap-2">
                                <button 
                                    onClick={() => setIsMobileOpacityPanelOpen(!isMobileOpacityPanelOpen)}
                                    className="p-2 bg-white dark:bg-gray-700 rounded-full shadow-md text-gray-600 dark:text-gray-300"
                                >
                                    <Sliders className="w-5 h-5" />
                                </button>
                                {isMobileOpacityPanelOpen && (
                                    <div className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm p-4 rounded-lg shadow-lg border dark:border-gray-700 space-y-4 w-48">
                                        <div className="space-y-1">
                                            <label className="text-xs font-medium text-gray-600 dark:text-gray-400 flex justify-between items-center">
                                                <span>Plan</span>
                                                <span className="font-mono text-gray-500 dark:text-gray-400">{Math.round(planOpacity * 100)}%</span>
                                            </label>
                                            <input 
                                                type="range" min="0" max="1" step="0.05" 
                                                value={planOpacity} 
                                                onChange={(e) => setPlanOpacity(parseFloat(e.target.value))}
                                                className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-600 accent-blue-600"
                                            />
                                        </div>
                                        <div className="space-y-1">
                                            <label className="text-xs font-medium text-gray-600 dark:text-gray-400 flex justify-between items-center">
                                                <span>Elements</span>
                                                <span className="font-mono text-gray-500 dark:text-gray-400">{Math.round(entitiesOpacity * 100)}%</span>
                                            </label>
                                            <input 
                                                type="range" min="0" max="1" step="0.05" 
                                                value={entitiesOpacity} 
                                                onChange={(e) => setEntitiesOpacity(parseFloat(e.target.value))}
                                                className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-600 accent-blue-600"
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <CanvasRenderer
                            isPanning={isPanning}
                            transform={transform}
                            pdfPage={pdfPage}
                            planOpacity={planOpacity}
                            renderableEntities={renderableEntities}
                            entitiesOpacity={entitiesOpacity}
                            unreadCounts={unreadCounts}
                            handleOpenFeedback={handleOpenFeedback}
                            entities={entities}
                            selectedEntity={selectedEntity}
                            selectedEntityIds={selectedEntityIds}
                            focusedArea={focusedArea}
                            isDark={isDark}
                            tool={tool}
                            canEdit={canEdit}
                            handleEntityClick={handleEntityClick}
                            onImageOrHandleMouseDown={onImageOrHandleMouseDown}
                            onAnchorMouseDown={onAnchorMouseDown}
                            selectedEdgeIndices={selectedEdgeIndices}
                            handleEdgeClick={handleEdgeClick}
                            renderPreview={renderPreview}
                            displayMode={displayMode}
                            materials={materials}
                            furniture={furniture}
                            decorativeImages={decorativeImages}
                            handleMaterialSelect={handleMaterialSelect}
                            handleFurnitureSelect={handleFurnitureSelect}
                            masterStyle={masterStyle}
                            showConfirmations={showConfirmations}
                            onConfirmItem={onConfirmItem}
                            currentUser={currentUser}
                            effectiveIsPreview={effectiveIsPreview}
                            draggedImageState={draggedImageState}
                            draggedAnchorState={draggedAnchorState}
                        />

                        {isRendering && (
                            <div className="z-20 flex items-center space-x-2 p-3 text-blue-600 bg-white/90 dark:bg-gray-800/90 rounded-lg shadow-lg border">
                                <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                                <span className="text-sm font-bold">Rendering...</span>
                            </div>
                        )}
                    </div>
                )}
                { mobileView === 'properties' && canManageProperties && (
                    <div className="p-4 flex flex-col h-full overflow-y-auto">
                        <PropertiesPanel
                            selectedEntity={selectedEntity}
                            selectedEntityIds={selectedEntityIds}
                            entities={entities}
                            onPropertyChange={onPropertyChange}
                            onDelete={handleDeleteSelectedEntity}
                            canManage={canEdit}
                            isDark={isDark}
                            handleRestoreAspectRatio={handleRestoreAspectRatio}
                            materials={materials}
                            furniture={furniture}
                            decorativeImages={decorativeImages}
                        />
                    </div>
                )}
            </div>
            <div className="h-16 border-t dark:border-gray-700 flex items-center px-4 bg-white dark:bg-gray-800 flex-shrink-0">
                <div className="w-full flex items-center justify-around">
                    <button onClick={() => setMobileView('plans')} className={`flex flex-col items-center justify-center p-2 rounded-lg w-20 ${mobileView === 'plans' ? 'text-blue-600 dark:text-blue-400' : 'text-gray-500 dark:text-gray-400'}`}>
                        <LayoutList className="h-5 w-5" />
                        <span className="text-xs font-medium mt-1">Plans</span>
                    </button>
                    <button onClick={() => setMobileView('canvas')} className={`flex flex-col items-center justify-center p-2 rounded-lg w-20 ${mobileView === 'canvas' ? 'text-blue-600 dark:text-blue-400' : 'text-gray-500 dark:text-gray-400'}`}>
                        <Square className="h-5 w-5" />
                        <span className="text-xs font-medium mt-1">Canvas</span>
                    </button>
                    {canManageProperties && <button onClick={() => setMobileView('properties')} className={`flex flex-col items-center justify-center p-2 rounded-lg w-20 ${mobileView === 'properties' ? 'text-blue-600 dark:text-blue-400' : 'text-gray-500 dark:text-gray-400'}`}>
                        <Settings2 className="h-5 w-5" />
                        <span className="text-xs font-medium mt-1">Properties</span>
                    </button>}
                </div>
            </div>
        </div>
    );
};
